module.exports = __webpack_public_path__ + "images/emoji/blossom.136d52899cfb540e45cf.png";